import { ActionIcon, Group, Menu, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/api/resources/auth/hooks";
import TermsMenu from "@/components/TermsMenu";
import { useAppVersion } from "@/hooks/useAppVersion";
import { getEnv } from "@/hooks/useEnv";
import { useNavigationAnonymous } from "@/hooks/useNavigation";
import { userName } from "@/utils/format";
import Icon from "@/utils/icons";

export const NavbarUserMenu = () => {
  const appVersion = useAppVersion();
  const { t } = useTranslation();
  const { signOut, profile } = useAuth();
  const { goToAccountSettings } = useNavigationAnonymous();

  const handleSignOut = () => {
    signOut();
  };

  return (
    <Menu width={260} position="bottom-end" transitionProps={{ transition: "pop-top-right" }} withinPortal>
      <Menu.Target>
        <ActionIcon variant="filled" size={60} p="sm" radius="xl">
          <Icon.USER_MENU size={60} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {profile && (
          <Menu.Item disabled>
            <b>{userName(profile)}</b>
            <br />
            <small>{profile.email}</small>
          </Menu.Item>
        )}

        <TermsMenu variant="submenu" />

        <Menu.Item component="a" leftSection={<Icon.HELP />} href={getEnv("VITE_DOCS_URL")} target="_blank">
          {t("navigation.help")}
        </Menu.Item>

        <Menu.Item leftSection={<Icon.USER_SETTINGS />} onClick={goToAccountSettings}>
          {t("account-settings")}
        </Menu.Item>

        <Menu.Item leftSection={<Icon.LOGOUT />} onClick={handleSignOut}>
          <Group wrap="nowrap" justify="space-between">
            {t("logout")}
            <Text size="xs" c="dimmed">
              {appVersion}
            </Text>
          </Group>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default NavbarUserMenu;
